const CHANNEL_NAME = "monument_session_sync";

let channel: BroadcastChannel | null = null;

type SessionMessage = { type: "LOGOUT" };

export function initSessionSync(onLogout: () => void) {
  if (typeof window === "undefined") return;

  channel = new BroadcastChannel(CHANNEL_NAME);

  channel.addEventListener("message", (event: MessageEvent<SessionMessage>) => {
    if (event.data.type === "LOGOUT") {
      onLogout();
    }
  });

  // Fallback для старых браузеров через storage event
  window.addEventListener("storage", (e) => {
    if (e.key === null || e.key === "monument_access_token") {
      if (!localStorage.getItem("monument_access_token")) {
        onLogout();
      }
    }
  });
}

export function broadcastLogout() {
  channel?.postMessage({ type: "LOGOUT" });
}
